import {roleClaimCandidates} from "../config/auth-config";

const normalizeRole = (value) => String(value).trim().toLowerCase();

export const ZITADEL_ROLE_USER = "fahrzeugverwaltung.user";
export const ZITADEL_ROLE_ADMIN = "fahrzeugverwaltung.admin";
export const ZITADEL_ROLE_READONLY = "fahrzeugverwaltung.readonly";

export const extractRolesFromProfile = (profile) => {
  if (!profile) {
    return [];
  }

  for (const claimName of roleClaimCandidates) {
    const claimValue = profile[claimName];

    if (!claimValue) {
      continue;
    }

    if (Array.isArray(claimValue)) {
      return claimValue.map(normalizeRole);
    }

    if (typeof claimValue === "string") {
      return [normalizeRole(claimValue)];
    }

    if (typeof claimValue === "object") {
      return Object.keys(claimValue).map(normalizeRole);
    }
  }

  return [];
};

export const isAdminByProfile = (profile) => {
  const roles = extractRolesFromProfile(profile);
  return roles.includes(ZITADEL_ROLE_ADMIN);
};

export const canWriteByProfile = (profile) => {
  const roles = extractRolesFromProfile(profile);
  return (
    roles.includes(ZITADEL_ROLE_ADMIN) || roles.includes(ZITADEL_ROLE_USER)
  );
};

export const isReadonlyByProfile = (profile) => {
  const roles = extractRolesFromProfile(profile);
  return (
    roles.includes(ZITADEL_ROLE_READONLY) &&
    !roles.includes(ZITADEL_ROLE_ADMIN) &&
    !roles.includes(ZITADEL_ROLE_USER)
  );
};

export const hasAppAccessByProfile = (profile) => {
  const roles = extractRolesFromProfile(profile);
  return (
    roles.includes(ZITADEL_ROLE_ADMIN) ||
    roles.includes(ZITADEL_ROLE_USER) ||
    roles.includes(ZITADEL_ROLE_READONLY)
  );
};
